'use strict';

module.exports = {
    LANG: 'es-es',
    SIGN: 'Inicia sesión',
    REGISTER: 'Regístrate',
    QUICK_ACCESS: 'Acceso rápido con',
    SIGN_JOIN: '¡Inicie sesión o regístrese gratis!',
    NOT_MEMBER: 'No tengo cuenta',
    ALREADY_MEMBER: 'Ya tengo cuenta',
    SHOW_ALL: 'Mostrar todo',
    HIDE: 'Ocultar'
};